import { ButtonCTA, CardBackground } from 'components/ui';
import { Link, useHistory } from 'react-router-dom';

export default function NotFoundPage() {
  const history = useHistory();
  return (
    <div className="relative max-w-screen-xl px-5 mx-auto md:pl-segments-72px md:pr-20 py-11">
      <p className="font-bold leading-6">404</p>
      <h1 className="mt-4 font-bold leading-10 text-segments-44px">
        Page not found
      </h1>
      <div className="mt-10">
        <CardBackground>
          <div className="flex flex-col items-center p-10">
            <p className="text-2xl font-bold">Problem occurred</p>
            <p className="mt-5 text-xl text-gray-700">
              We're probably moving some stuff around, sorry! Here are links to
              your{' '}
              <Link to="/dashboard" className="font-bold text-segments-link">
                dashboard{' '}
              </Link>
              and your{' '}
              <Link
                to="/account/stores"
                className="font-bold text-segments-link"
              >
                stores
              </Link>
              .
            </p>
            <div>
              <img
                src="/assets/image-problem-occurred.png"
                width="603"
                height="292"
                alt="problem occurred"
              />
            </div>
            <div className="flex justify-center mt-10">
              <ButtonCTA
                type="button"
                variant="main"
                onClick={() =>
                  history.replace({
                    pathname: '/dashboard',
                  })
                }
              >
                <p className="px-4">Go to Dashboard</p>
              </ButtonCTA>
            </div>
          </div>
        </CardBackground>
      </div>
    </div>
  );
}
